<template>
  <section
    v-loading.fullscreen.lock="loading"
    :element-loading-text="loadingText"
    class="patient-report"
  >
    <div v-if="getEmailPatientReportData">
      <div v-show="showForm">
        <FormLogo :displayApp="reportLab" v-if="reportLab"></FormLogo>
        <div class="otp-card-group">
          <div v-if="getEmailPatientReportData" class="otp-card">
            <div class="heading">
              <div class="accession-id each-line">
                <span>Accession :</span>
                {{ getEmailPatientReportData.accession_id || "" }}
              </div>
              <div class="case-type each-line">
                <span>Case Type :</span>
                {{ caseTypeMap[getEmailPatientReportData.case_type] || "" }}
              </div>
              <div class="case-type each-line" v-if="verifyDOB">
                <span>DOB :</span>
                {{
                  formatDate(
                    getEmailPatientReportData.patient_info.date_of_birth
                  )
                }}
              </div>
            </div>
            <div>
              <dobNew :dobData="formData" v-show="!verifyDOB"></dobNew>

              <el-button
                v-if="!verifyDOB"
                type="primary"
                class="button-group"
                :disabled="!formData.date_of_birth"
                @click="getOTP()"
                >Submit</el-button
              >
            </div>

            <div v-show="verifyDOB">
              <label>OTP:</label>
              <OtpInput
                class="opt-input-group"
                ref="otpInput"
                input-classes="otp-input"
                separator=" "
                :num-inputs="4"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChange"
                @on-complete="handleOnComplete"
                @keyup.enter.prevent="verifyOTP()"
              />

              <ul class="action-buttons">
                <li>
                  <el-button
                    type="primary"
                    class="verify-button"
                    @click="verifyOTP()"
                    >Verify</el-button
                  >
                </li>
                <li>
                  <el-button
                    type="text"
                    class="verify-button"
                    @click="resendOTPEmail()"
                    :disabled="countDown ? true : false"
                    >Resend OTP</el-button
                  >
                </li>
                <li>
                  <span v-if="countDown" class="timer"> {{ countDown }}</span>
                </li>
              </ul>
            </div>
            <FormError errorName="critical_error"></FormError>
          </div>
        </div>
      </div>
    </div>
    <div v-if="getPatientReportPReviewEmailURL">
      <div class="download-strip">
        <el-button @click="reportDownload" class="download-report"
          >Download</el-button
        >
      </div>

      <VuePdf
        v-for="i in numPages"
        :key="i"
        :src="getPatientReportPReviewEmailURL"
        style="display: block; width: 80%; margin: 0 10% 20px"
        :page="i"
      ></VuePdf>
    </div>
    <div v-else-if="!loading && this.getError">
      <div class="report-error-display">
        <div class="icon">
          <img src="@/assets/img/warning.svg" alt="" class="img-fluid" />
        </div>
        <h3 class="color-red">{{ getError || "Error in loading data" }}</h3>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import OtpInput from "vue3-otp-input";
import FormLogo from "@/components/patientReport/header/FormLogo";
import caseConstants from "@/config/constants/caseConstants";
import { VuePdf, createLoadingTask } from "vue3-pdfjs";
import {
  errorNotification,
  successNotification,
} from "@/helpers/notifications";
import moment from "moment";
import dobNew from "@/components/misc/DobNewFormat";
export default {
  components: {
    VuePdf,
    OtpInput,
    dobNew,
    FormLogo,
  },
  data() {
    return {
      loading: false,
      loadingText: "Loading...",
      showForm: true,

      otp: null,
      reportLab: "",
      numPages: 1,

      openErrorDialog: false,
      displayPatientDob: true,

      formData: { date_of_birth: "" },

      verifyDOB: false,
      countDown: 0,
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
    };
  },
  mounted() {
    this.fetchReportInfo();
  },
  computed: {
    ...mapGetters("patientReport", [
      "getPatientReportData",
      "getPatientReportAccessStatus",
      "getPatientReportPReviewEmailURL",
      "getReportIframeURL",
      "getValidateWithDOBData",
      "getResendOTPStatus",
      "getEmailPatientReportData",
      "getValidateEmailWithDOBData",
      "getPatientReportEmailAccessStatus",
      "getResendOTPEmailStatus",
    ]),
    ...mapGetters("errors", ["getError", "getErrors"]),
  },

  methods: {
    async resendOTPEmail() {
      var input = this.formData.date_of_birth;
      if (input.length) {
        const dateValidate = moment(input);
        if (!dateValidate.isValid()) {
          this.$message({
            message: "Invalid DOB!",
            type: "warning",
          });

          return null;
        }
      }
      try {
        this.loading = true;

        let params = {
          reportId: this.$route.params.report_id,
          params: this.formData,
        };
        await this.$store.dispatch("patientReport/resendOTPEmail", params);
        if (this.getResendOTPEmailStatus) {
          successNotification("OTP Send Successfully");
          this.countDown = 60;
          this.countDownTimer();
        } else {
          errorNotification("Error in sending OTP");
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    async verifyOTP() {
      try {
        let params = {
          reportId: this.$route.params.report_id,
          params: {
            passcode: this.otp,
          },
        };
        this.loading = true;
        await this.$store.dispatch(
          "patientReport/checkEmailReportPreview",
          params
        );
        if (
          this.getPatientReportEmailAccessStatus &&
          this.getPatientReportPReviewEmailURL
        ) {
          await this.fetchPageCountofReport();
          this.showForm = false;
        } else if (this.getError) {
          errorNotification(this.getError || "Invalid OTP");
        }
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    handleOnComplete(value) {
      this.otp = value;
    },
    handleOnChange(value) {
      this.otp = value;
    },
    async getOTP() {
      var input = this.formData.date_of_birth;
      if (input.length) {
        const dateValidate = moment(input);
        if (!dateValidate.isValid()) {
          this.$message({
            message: "Invalid DOB!",
            type: "warning",
          });

          return null;
        }
      }
      try {
        this.loading = true;
        this.verifyDOB = false;
        let params = {
          reportId: this.$route.params.report_id,
          params: this.formData,
        };
        await this.$store.dispatch(
          "patientReport/validateEmailWithDOB",
          params
        );
        if (this.getValidateEmailWithDOBData) {
          this.verifyDOB = true;
        }
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.verifyDOB = false;
        console.log(error);
      }
    },

    async fetchReportInfo() {
      try {
        this.loading = true;

        let reportId = this.$route.params.report_id;

        await this.$store.dispatch(
          "patientReport/fetchPatientEmailReportData",
          reportId
        );
        if (
          this.getEmailPatientReportData &&
          this.getEmailPatientReportData.lab_info &&
          this.getEmailPatientReportData.lab_info.lab_code
        ) {
          this.reportLab = this.getEmailPatientReportData.lab_info.lab_code;
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    reportDownload() {
      try {
        const link = document.createElement("a");
        link.href = this.getPatientReportPReviewEmailURL;

        link.setAttribute("download", ""); //or any other extension
        document.body.appendChild(link);
        link.click();
        successNotification("Report downloaded successfully");
      } catch (err) {
        errorNotification("Error in report download");
      }
    },
    async fetchPageCountofReport() {
      const pdfUrl = createLoadingTask(this.getPatientReportPReviewEmailURL);

      await pdfUrl.promise.then((pdf) => {
        this.numPages = pdf._pdfInfo.numPages;
      });
    },
  },
};
</script>

<style lang="scss">
.patient-report {
  .otp-card-group {
    max-width: 450px;
    margin: 0 auto;
  }
  .button-group {
    display: flex;
    justify-content: center;
    margin: 0 auto;
  }
  .each-line {
    display: flex;
    span {
      display: inline-block;
      min-width: 90px;
    }
  }
  .action-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2em;
    li {
      margin-right: 10px;
      .el-button {
        padding: 10px 15px;
        border-radius: 5px;
        margin: 0 !important;
      }
      .timer {
        background: #f44335;
        width: 30px;
        height: 30px;
        display: flex;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
      &:nth-child(1) {
        .el-button {
          background: #2196f3;
          color: #fff;
        }
      }
      &:nth-child(2) {
        .el-button {
          background: #f44336;
          color: #fff;
        }
      }
    }
  }
  .otp-card {
    background: #fff;
    padding: 30px;
    margin: 0 15px;
    border-radius: 10px;
    @media (max-width: 510px) {
      max-width: 97% !important;
    }
    .opt-input-group {
      justify-content: center;
      > div {
        &:not(:last-child) {
          margin-right: 15px;
        }
      }
      .otp-input {
        height: 35px;
        max-width: 45px;
        text-align: center;
        font-weight: 600;
        font-size: 18px;
        @media (max-width: 300px) {
          max-width: 35px;
        }
        @media (max-width: 250px) {
          max-width: 30px;
        }
      }
    }
    .heading {
      margin-bottom: 25px;
      .accession-id {
        margin-bottom: 5px;
      }
    }
    .verify-button {
      margin-top: 2em;
      padding: 10px 25px;
      font-weight: 600;
      text-transform: uppercase;
      &.is-disabled {
        opacity: 0.6;
      }
    }
    .error {
      color: red;
    }
  }
  .download-strip {
    background: #f2f2f2;
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
    margin: 0 10% 10px;

  }
  .report-pdf {
    display: block;
    width: 80%;
    margin: 0 10% 20px;
    @media (max-width: 500px) {
      width: 90%;
      margin: 0 5% 20px;
    }
  }
  .download-report {
    color: #fff;
    background-color: #1a78da;
    border-color: #409eff;
    font-weight: 600;
    padding: 7px 10px;
    font-size: 13px;
    @media (max-width: 500px) {
      font-size: 11px;
    }
  }
}
.report-error-display {
  text-align: center;
  margin-top: 10vh;
  img {
    width: 40px;
    margin-bottom: 15px;
  }
  .color-red {
    color: red;
  }
}
</style>
